import { createContext } from 'react';
export const ThemeContext = createContext('');
export const ThemeUpdateContext = createContext(null);
